import { CrunchServiceWithContext } from "@crunchdao/sdk";
import { EnhancedBaseCommand } from "@crunchdao/shared-cli";

export class StartCommand extends EnhancedBaseCommand {
  async execute(crunchName: string): Promise<void> {
    const crunchService = CrunchServiceWithContext({
      program: this.program,
    });

    try {
      await this.executeOrProposeInstructions(async () => {
        return [await crunchService.startCrunchInstruction(crunchName, this.getSigner())];
      }, `Start crunch "${crunchName}"`);

      if (!this.isMultisigMode()) {
        this.success("Crunch started successfully", {
          crunchName: crunchName,
        });
      }
    } catch (error) {
      this.handleStartError(error, crunchName);
    }
  }

  private handleStartError(error: any, crunchName: string): never {
    // Check for invalid crunch state to start error - multiple detection methods
    const isInvalidCrunchState = error?.error?.errorCode.code === "InvalidCrunchStateToStart";

    if (isInvalidCrunchState) {
      const customError = this.createEnhancedError(
        `Cannot start crunch "${crunchName}". The crunch is not in the created state (it may already be started, ended, or in another state).`,
        "InvalidCrunchStateError",
        "INVALID_CRUNCH_STATE_TO_START",
        {
          crunchName,
          errorCode: error.error?.errorCode?.code || "InvalidCrunchStateToStart",
          errorNumber: error.error?.errorCode?.number || 6008,
          suggestion: "Check the crunch status using: crunch get <name>",
        },
        error
      );

      return this.handleError(customError);
    }

    // Fall back to generic transaction error handling
    return this.handleTransactionError(error, crunchName);
  }
}
